<template lang="html">
    <v-form ref="form" >
        <v-container grid-list-xs>
            <v-layout wrap>
                <!-- #region - step 1 -- check the article code -->
                <v-flex xs12 v-if="step===1">
                    <v-layout>
                        <v-flex xs12>
                            <v-form v-model="code_ok">
                                <v-text-field
                                label="Code article"
                                v-model="product_code"
                                required
                                :color="ERP_color"
                                :loading="ERP_loading"
                                :error="ERP_error"
                                :hint="ERP_message"
                                :rules="rules.product_code"
                                @input="onCodeInput"
                                >
                                </v-text-field>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <!-- #endregion -->

                <!-- #region - step 2 -- select project -->
                <v-flex v-if="this.step===2" xs12>
                    <v-select
                        label="Relier à un projet"
                        autocomplete
                        chips
                        clearable
                        :items="projects"
                        item-text="label"
                        item-value="id"
                        v-model="project_id"
                        >
                    </v-select>

                    <v-select
                        v-if="project_id != null"
                        label="Produit Fournisseur"
                        autocomplete
                        chips
                        clearable
                        :items="suppliers"
                        item-text="label"
                        item-value="id"
                        v-model="supplier_id"
                        @change=""
                        >
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <v-avatar>
                                    <img :src="supplier_product_avatar(data)"/>
                                </v-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.label }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-select>
                </v-flex>
                <!-- #endregion -->

                <!-- #region - step 3 -- export requests & comments -->
                <v-flex xs12 v-if="step===3 && this.project_id != null">
                    <data-table
                        :headers="datatable.headers"
                        :endpoint="datatable.endpoint"
                        storeId="comments"
                        ref="list"
                    >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-right">
                            <v-checkbox hide-details v-model="props.item.request_selected" @change="setRequest(props.item)" color="accent"></v-checkbox>
                        </td>
                        <td class="text-xs-right">
                            <v-checkbox hide-details v-model="props.item.comment_selected" @change="setComment(props.item)" color="accent"></v-checkbox>
                        </td>
                        <td class="text-xs-right">
                            {{props.item.user.first_name}} {{props.item.user.last_name}}
                        </td>
                        <td class="text-xs-right">
                            {{moment(props.item.created_at).format('DD/MM/YYYY')}}
                        </td>
                        <td class="text-xs-center">
                            <v-icon :style="{color: getCommentColor(props.item.type)}">fiber_manual_record</v-icon>
                        </td>
                        <td class="text-xs-right">
                            {{props.item.message}}
                        </td>
                    </template>
                    </data-table>
                </v-flex>
                <!-- #endregion -->

                <!-- #region - step 3 --bis -- select / create supplier if no project-->
                <v-flex v-if="this.step === 3 && project_id == null" xs12>
                    <v-select
                      :items="suppliers"
                      v-model="supplier_id"
                      label="Fournisseur"
                      item-text="name"
                      item-value="id"
                      autocomplete
                      autofocus
                      ref="select"
                      :loading="add_new"
                      clearable
                      @keyup.enter.native="addTag($event)"
                    >
                    <template slot="selection" slot-scope="data">
                        <v-chip>
                            {{ data.item.name }}
                        </v-chip>
                    </template>
                    <template slot="item" slot-scope="data">
                        <template v-if="typeof data.item === 'object'">
                            <v-list-tile-content>
                                <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                    <template slot="no-data">
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>Appuyer sur Entrer pour ajouter</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                    </v-select>
                </v-flex>
                <!-- #endregion -->

                <!-- #region - step 4 - loading -- convert -->
                <div class="loader" v-if="step === 4">
                    <img src="../../../assets/img/grid_loader.svg" />
                    <p>Ajout du produit en cours</p>
                </div>
                <!-- #endregion -->
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
import DataTable from '../../../components/DataTable.vue'
import { CommentTypes } from '../../../config/enum/CommentTypes'
import moment from 'moment'

export default {
    components: { DataTable },
    data(){
        return {
            title:    'Ajouter un produit',
            icon:     'add_circle',
            isValid:  false,
            width: '1000px',
            model: {},
            ERP_color: 'primary',
            ERP_error: false,
            ERP_message: null,
            ERP_loading: false,
            step: 1,
            product_code: '',
            valid_button: false,
            next_button: true,
            created_product_id: '',
            code_ok: false,
            code_accepted: false,
            project_id: null,
            supplier_id: null,
            projects: [],
            suppliers: [],
            comments: [],
            requests: [],
            add_new:false,
            moment,
            disableEnter: true,
            rules: {
                product_code: [
                    (v) => !!v && !isNaN(v) && v.length > 5 || 'Code de 6 chiffres obligatoire',
                ]
            },
            datatable: {
                headers: [
                    { text: 'Demandes', sortable: false, value: 'is_request', align: 'right' },
                    { text: 'Commentaires', sortable: false, value: 'is_comment', align: 'right' },
                    { text: 'Auteur', sortable: true, value: 'user_id', align: 'right' },
                    { text: 'Date', sortable: true, value: 'created_at', align: 'right' },
                    { text: 'Tonalite', sortable: false, value: 'type', align: 'center' },
                    { text: 'Message', sortable: false, align: 'right' }
                ],
                endpoint: {
                    base: '/api/comments',
                    filters: 'product_id|=|',
                    embed: 'user'
                }
            }
        }
    },
    watch: {
        project_id(val){
            if(val){
                this.suppliers = this.$_.find(this.projects, p => p.id == this.project_id).supplier_products
            }
        },
        supplier_id(val){
            if(val && this.project_id != null){
                this.$eventHub.$emit('set-next-button', true)
                this.$eventHub.$emit('set-valid-button', false)
                this.datatable.endpoint.filters = 'product_id|=|'+val
            } else {
                this.$eventHub.$emit('set-next-button', false)
                this.$eventHub.$emit('set-valid-button', true)
            }
        }
    },
    methods: {
        onCodeInput() {
        const isValidLength = !!this.product_code && !isNaN(this.product_code) && this.product_code.length > 5;

        if (!isValidLength) {
            this.ERP_error = true;
            this.ERP_color = 'error';
            this.ERP_message = 'Code de 6 chiffres obligatoire';
            return;
        }

        this.sendCode(this.product_code);
    },
        sendCode(value) {
            this.ERP_loading = true

            this.axios.get(`/api/products/erp-synchro/${value}`)
                .then(res => {
                    this.ERP_error   = false
                    this.ERP_color   = 'success'
                    this.ERP_loading = false
                    this.ERP_message = res.data.label

                    this.code_accepted=true;
                    this.$eventHub.$emit('set-next-button', true)

                })
                .catch(err => {
                    if(err.response.data.status_code == 422) {
                        this.ERP_color   = 'primary'
                        this.ERP_error   = true
                        this.ERP_loading = false
                        this.ERP_message = err.response.data.message

                    } else {
                        console.log(err.response.data)
                    }

                    this.$eventHub.$emit('set-next-button', false);
                    this.code_accepted=false;
                });
        },
        onClose() {
            this.$eventHub.$emit('close-modal')
        },
        onNextStep() {
            this.step++;
            this.$eventHub.$emit('set-valid-button', false)
            this.$eventHub.$emit('set-next-button', true)
        },
        onValidate() {

        },
        getProjects(){
            this.axios.get('/api/projects?embed=supplier_products')
            .then(response => {
                this.projects = response.data
            })
        },
        supplier_product_avatar(data) {
            if (data.item.photo === null) {
                return require('../../../assets/img/defaultProduct.png');
            } else {
                return data.item.photo
            }
        },

        getCommentColor: function(type) {
            let commentType = CommentTypes.find((el) => {
                return el.value === type
            });
            return commentType ? commentType.color : '';
        },

        setComment(item) {
            let index = this.comments.indexOf(item.id)

            if(item.comment_selected) {
                if(index == -1) {
                    this.comments.push(item.id)
                }

            } else {
                if(index > -1) {
                    this.comments.splice(index, 1)
                }
            }
        },

        addTag(val){
            if(val.target.value != "" && this.suppliers.filter(s => s.name == val.target.value.toLowerCase()).length == 0 && this.suppliers.filter(s => s.name == val.target.value.toUpperCase()).length == 0){
                this.add_new = true
                this.axios.post(`/api/suppliers`, {name:val.target.value})
                .then(response => {
                    this.suppliers.push(response.data)
                    this.supplier_id = response.data.id
                    if(this.$refs.select) {
                        this.$refs.select.searchValue = null
                    }
                    this.add_new = false
                })
            }
        },
        getSuppliers() {
            this.axios.get(`/api/suppliers`)
            .then(response => {
                this.suppliers = response.data
                this.loading = false
            })
        },

        setRequest(item) {
            let index = this.requests.indexOf(item.id)

            if(item.request_selected) {
                if(index == -1) {
                    this.requests.push(item.id)
                }

            } else {
                if(index > -1) {
                    this.requests.splice(index, 1)
                }
            }
        },
        onValidate() {
            this.step = 4;
            this.$eventHub.$emit('hide-modal-actions');
            if(this.project_id != null && this.supplier_id != null){
                this.model = {
                    num: this.product_code,
                    root_product_id: this.supplier_id,
                    comment_ids: this.comments,
                    request_ids: this.requests,
                }
            } else if(this.project_id != null){
                this.model = {
                    num: this.product_code,
                    project_id: this.project_id
                }
            } else if(this.project_id == null && this.supplier_id != null){
                this.model = {
                    num: this.product_code,
                    supplier_id: this.supplier_id
                }
            } else {
                this.model = {
                    num: this.product_code
                }
            }

            this.axios.post('/api/products/erp-synchro', this.model)
                .then(res  => {
                    let interval = setInterval(() => {
                        this.axios.get(`/api/products/${res.data.id}`)
                            .then(r => {
                                if(!r.data.is_syncing) {
                                    clearInterval(interval)
                                    this.axios.get(`/api/products/${res.data.id}?embed=category.parent.parent`)
                                    .then(response => {
                                        this.$eventHub.$emit('close-modal');

                                        this.$router.push({
                                            name: 'single-product',
                                            params: {
                                                super_family: response.data.category.parent.parent.label,
                                                id: res.data.id
                                            }
                                        })
                                    })
                                }
                            })

                    }, 3000);

                })
                .catch(err  => console.log(err.response.data))

        }
    },
    created(){
        this.$eventHub.$emit('set-next-button', false);
        this.$eventHub.$emit('set-valid-button', false);
    },
    mounted() {
        this.getProjects();
        this.getSuppliers();
    }
}
</script>

<style lang="stylus" scoped>
.icon-flex-container {
    display: flex

    .code-input-icon-container {
        display: flex
        justify-content: space-around
        flex: 1
        vertical-align: center
        text-align: center
    }
}

.loader
    display flex
    flex-direction column
    align-items center
    width 100%
    padding 3rem 0

    img
        margin 0 0 3rem
</style>



// WEBPACK FOOTER //
// src/views/products/list/Create.vue